import Axios from 'axios'
import QS from 'qs'
import Vue from 'vue'
import router from '../router/index'
import api from '../api/api'

Vue.prototype.$api = api;

Axios.defaults.timeout = 15000;
Axios.defaults.withCredentials = true;
// Axios.defaults.baseURL = process.env.NODE_ENV==='production' ? process.env.BASE_API : '';
Axios.defaults.baseURL = process.env.BASE_API;
Axios.interceptors.request.use((config) => {  

  //在请求头中添加token验证信息
  if (config.url != Vue.prototype.$api.login.webLogin) {  
    config.headers.common['user-news-information-token'] = localStorage.getItem("newsWebToken");
  };
  
  // //在发送请求之前做某件事g
  // if (config.method === 'post') {
  //   config.data = QS.stringify(config.data);
  // }

  return config;

}, (error) => { 
  // 可能出现错误的参数
  return Promise.reject(error);
});

Axios.interceptors.response.use((response) => {
  switch (response.data.code) {
    //判断用户登陆是否失效
    case 501 || 400:
      localStorage.removeItem("newsWebToken");
      router.replace({path: "/login"});
      if(!Vue.prototype.variable.FLAG_LOGIN_ERROR_NOAUTH) {
        Vue.prototype.msg_warning(Vue.prototype.variable.TEXT_LOGIN_ERROR_NOAUTH);
        Vue.prototype.variable.FLAG_LOGIN_ERROR_NOAUTH = true;
      }
      break;
  }
  //如果需要刷新token，可以按照以下代码修改
  // let token = response.headers[Vue.prototype.variable.RTOKEN];
  // if(token) {
  //   localStorage.setItem(Vue.prototype.variable.TOKEN,token);
  // }
  return response;
}, (error) => {
  if (error.response.code) {
    switch (error.response.code) {
      case 501 || 400:
        localStorage.removeItem("newsWebToken");
        router.replace({path: "/login"});
        if(!Vue.prototype.variable.FLAG_LOGIN_ERROR_NOAUTH) {
          Vue.prototype.msg_warning(Vue.prototype.variable.TEXT_LOGIN_ERROR_NOAUTH);
          Vue.prototype.variable.FLAG_LOGIN_ERROR_NOAUTH = true;
        }
        break;
      default:
        break;
    }
  }
  return Promise.reject(error.response.data);
});

export function post(url, params) {
  return new Promise((resolve, reject) => {
    Axios.post(url, params,{processData:true})
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 如果含有文件，直接使用post即可
// export function postFile(url, params) {
//   return new Promise((resolve, reject) => {
//     Axios.post(url, params, {headers: {'Content-Type': 'multipart/form-data'}})
//       .then(response => {
//         resolve(response);
//       }, err => {
//         reject(err);
//       })
//       .catch((error) => {
//         reject(error)
//       })
//   })
// }

export function put(url, params) {
  return new Promise((resolve, reject) => {
    Axios.put(url, params)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function get(url,param) { 
  return new Promise((resolve, reject) => { 
    Axios.get(url, {params: param})
      .then(response => { 
        
        resolve(response.data)
      }, err => {  
        reject(err)
      })
      .catch((error) => {  
        reject(error)
      })
  })
}

// export function del(url, param) {
//   return new Promise((resolve, reject) => {
//     Axios.delete(url, {
//       params: param, paramsSerializer: params => {
//         return QS.stringify(params, {indices: false})
//       }
//     })
//       .then(response => {
//         resolve(response)
//       }, err => {
//         reject(err)
//       })
//       .catch((error) => {
//         reject(error)
//       })
//   })
// }

export default {
  post,
  put,
  get,
  // del
}



// WEBPACK FOOTER //
// ./src/api/https.js